import {
  AlertTriangle,
  ArrowRight,
  Calendar,
  Check,
  ChevronLeft,
  ChevronRight,
  ChevronDown,
  CircuitBoardIcon,
  Command,
  CreditCard,
  Database,
  Download,
  File,
  Facebook,
  FileText,
  Headset,
  HelpCircle,
  Image,
  Infinity as InfinityIcon,
  Instagram,
  Laptop,
  LayoutDashboardIcon,
  Loader2,
  LogIn,
  LucideProps,
  MoveUpRight,
  Moon,
  MoreVertical,
  Phone,
  PiggyBank,
  Pizza,
  Plus,
  RefreshCw,
  Rocket,
  Settings,
  ShieldCheck,
  SignalHigh,
  SunMedium,
  Tag,
  Trash,
  Twitter,
  User,
  User2Icon,
  UserX2Icon,
  Wifi,
  X,
  Percent,
  UserCog,
  Zap
} from 'lucide-react';

export const Icons = {
  calendar: Calendar,
  dashboard: LayoutDashboardIcon,
  logo: Command,
  login: LogIn,
  close: X,
  profile: User2Icon,
  spinner: Loader2,
  kanban: CircuitBoardIcon,
  chevronLeft: ChevronLeft,
  chevronRight: ChevronRight,
  chevronDown: ChevronDown,
  document: FileText,
  trash: Trash,
  employee: UserX2Icon,
  post: FileText,
  page: File,
  media: Image,
  settings: Settings,
  billing: CreditCard,
  ellipsis: MoreVertical,
  add: Plus,
  warning: AlertTriangle,
  user: User,
  moveUpRight: MoveUpRight,
  arrowRight: ArrowRight,
  help: HelpCircle,
  pizza: Pizza,
  sun: SunMedium,
  moon: Moon,
  laptop: Laptop,
  x: ({ ...props }: LucideProps) => (
    <svg
      aria-hidden="true"
      focusable="false"
      data-prefix="fab"
      data-icon="x"
      role="img"
      // stroke="currentColor"
      // fill="currentColor"
      strokeWidth="0"
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"
        fill="#ffffff"
      ></path>
    </svg>
  ),
  globe: ({ ...props }: LucideProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM10 3C10.6568 3 11.4068 3.59025 12.0218 4.90814C12.2393 5.37419 12.4283 5.90978 12.5806 6.5H7.41936C7.57172 5.90978 7.76073 5.37419 7.97822 4.90814C8.59323 3.59025 9.34315 3 10 3ZM7.07203 4.48526C6.79564 5.07753 6.56498 5.75696 6.38931 6.5H3.93648C4.77295 5.05399 6.11182 3.93497 7.71442 3.38163C7.47297 3.71222 7.25828 4.08617 7.07203 4.48526ZM6.19265 7.5C6.06723 8.28832 6 9.12934 6 10C6 10.8707 6.06723 11.7117 6.19265 12.5H3.45963C3.16268 11.7236 3 10.8808 3 10C3 9.1192 3.16268 8.2764 3.45963 7.5H6.19265ZM6.38931 13.5C6.56498 14.243 6.79564 14.9225 7.07203 15.5147C7.25828 15.9138 7.47297 16.2878 7.71442 16.6184C6.11182 16.065 4.77295 14.946 3.93648 13.5H6.38931ZM7.41936 13.5H12.5806C12.4283 14.0902 12.2393 14.6258 12.0218 15.0919C11.4068 16.4097 10.6568 17 10 17C9.34315 17 8.59323 16.4097 7.97822 15.0919C7.76073 14.6258 7.57172 14.0902 7.41936 13.5ZM12.7938 12.5H7.20617C7.07345 11.7253 7 10.8833 7 10C7 9.11669 7.07345 8.27472 7.20617 7.5H12.7938C12.9266 8.27472 13 9.11669 13 10C13 10.8833 12.9266 11.7253 12.7938 12.5ZM13.6107 13.5H16.0635C15.2271 14.946 13.8882 16.065 12.2856 16.6184C12.527 16.2878 12.7417 15.9138 12.928 15.5147C13.2044 14.9225 13.435 14.243 13.6107 13.5ZM16.5404 12.5H13.8074C13.9328 11.7117 14 10.8707 14 10C14 9.12934 13.9328 8.28832 13.8074 7.5H16.5404C16.8373 8.2764 17 9.1192 17 10C17 10.8808 16.8373 11.7236 16.5404 12.5ZM12.2856 3.38163C13.8882 3.93497 15.2271 5.05399 16.0635 6.5H13.6107C13.435 5.75696 13.2044 5.07753 12.928 4.48526C12.7417 4.08617 12.527 3.71222 12.2856 3.38163Z"
        fill="currentColor"
      />
    </svg>
  ),
  fire: ({
    className,
    width,
    height,
    color,
    ...props
  }: LucideProps & { width?: number; height?: number; color?: string }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      className={className}
      width={width || 20}
      height={height || 20}
      fill="none"
    >
      <path
        d="M10.7853 2C10.7692 2.00077 10.753 2.00385 10.7369 2.00615C8.03851 2.41153 6.66086 3.75995 6.15005 5.18994C5.64007 6.6199 5.91391 8.03365 6.31698 8.81069C6.60005 9.35759 6.79389 10.213 6.71696 10.8053C6.67927 11.1014 6.58004 11.3184 6.45543 11.4414C6.33005 11.5645 6.16698 11.6406 5.82005 11.6137C5.49005 11.5876 5.41083 11.5014 5.33313 11.3583C5.25544 11.2153 5.21929 10.9568 5.2439 10.663C5.26929 10.3691 5.34851 10.0499 5.42082 9.80531C5.45697 9.683 5.49159 9.5807 5.51851 9.49992C5.53159 9.45992 5.5439 9.42685 5.55389 9.39531C5.55851 9.37993 5.56313 9.36762 5.56851 9.34685C5.57159 9.33685 5.57543 9.32377 5.57928 9.30608C5.58312 9.28839 5.58851 9.20993 5.58851 9.20839C5.58774 8.81686 5.1262 8.60686 4.82929 8.86455C4.59007 9.07378 3.9693 9.69685 3.50393 10.6722C3.03855 11.6476 2.75394 12.9868 3.29316 14.4759C4.06546 16.7243 5.53705 17.6089 6.5439 17.905H6.55467C6.8839 17.9935 7.2585 17.952 7.52389 17.6981C7.7785 17.455 7.84541 17.0627 7.75079 16.6981C7.62618 16.022 7.77541 15.5782 8.07156 15.1366C8.3677 14.6951 8.83846 14.2805 9.32845 13.8213C9.81768 13.3621 10.3269 12.8498 10.6292 12.1559C10.7492 11.8798 10.6007 11.4559 10.633 11.1259C10.8784 11.4906 11.3053 11.9382 11.3915 12.2198C11.563 12.779 11.4961 13.1821 11.3223 13.579C11.1492 13.9766 10.8492 14.3513 10.5492 14.7328C10.2492 15.1136 9.92769 15.5005 9.83461 16.0235C9.68615 16.862 9.97537 17.4612 10.3577 17.7235C10.5484 17.8543 10.7369 17.9073 10.87 17.935C10.913 17.9443 10.9392 17.9466 10.9677 17.9504C10.9738 17.9512 10.9823 17.955 10.9869 17.9558C10.9907 17.9566 10.9992 17.955 11.0023 17.9558C11.0061 17.9573 11.0092 17.9604 11.0115 17.9612C11.0346 17.9658 11.0584 17.965 11.0823 17.9666C11.5476 18.0327 12.9576 18.1173 14.5545 16.9612L14.553 16.9558C14.7807 16.8197 14.9915 16.6735 15.1761 16.5112C16.0684 15.7258 16.5261 14.7251 16.7376 13.7673C17.0637 12.4974 16.9653 10.9843 16.6399 10.0481C16.4607 9.59046 15.8591 9.60507 15.7522 10.0681C15.6753 10.3989 15.4815 10.5043 15.2399 10.5804C15.1491 10.6089 15.0668 10.6166 14.9884 10.6243C14.8561 10.1812 14.7269 9.72891 14.3146 9.21586C13.7938 8.56741 12.9846 7.85358 11.6731 6.95897C10.5323 6.1813 10.4423 5.20748 10.5939 4.31278C10.7462 3.41894 11.19 2.70204 11.19 2.70204C11.3831 2.39051 11.1515 1.98974 10.7854 2.00205L10.7853 2ZM12.7667 4.28918C12.7583 4.28995 12.7498 4.29226 12.7421 4.29303C12.6691 4.30303 12.6052 4.34687 12.5698 4.41149C12.5698 4.41149 12.3683 4.78995 12.3037 5.29762C12.239 5.8053 12.3198 6.47683 12.869 7.02604C13.3744 7.53141 13.899 7.94293 14.2782 8.30217C14.6575 8.66139 14.7967 8.95293 14.8398 9.19368C14.8752 9.44984 15.1621 9.54906 15.2736 9.31753C15.4682 8.95291 15.4997 8.60677 15.4967 8.31293C15.4997 7.73524 15.2759 6.98295 14.4613 6.35681C13.7198 5.78606 13.3552 5.30298 13.176 4.97761C13.0867 4.81454 13.0437 4.69224 13.0221 4.61223C13.0006 4.53222 13.0029 4.51454 13.0029 4.51454C12.9998 4.38685 12.8944 4.28686 12.7667 4.2907L12.7667 4.28918Z"
        fill={color || 'white'}
      />
    </svg>
  ),
  diamond: ({
    className,
    width,
    height,
    color,
    ...props
  }: LucideProps & { width?: number; height?: number; color?: string }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      className={className}
      width={width || 20}
      height={height || 20}
      fill="none"
    >
      <path
        d="M13.5308 7.10938L10.6602 17.5386C10.6702 17.5279 10.6802 17.5164 10.6887 17.5043L13.173 14.2972C13.0116 14.1986 12.7709 14.1836 12.6109 14.085C12.1652 13.8172 12.2316 12.9793 12.7602 12.8458H12.7594C13.2223 12.7786 13.6066 12.4536 13.7495 12.0086L13.8123 11.7936V11.7929C13.8952 11.5236 14.1502 11.3436 14.4316 11.3572C14.7294 11.3308 15.0087 11.5022 15.1202 11.7786L17.8537 8.24511C17.9244 8.15226 17.9737 8.04584 18.0001 7.93226L13.5308 7.10938Z"
        fill={color || 'white'}
      />
      <path
        d="M6.12432 6.59018C5.87717 6.21661 4.7279 4.48368 4.50646 4.14941C4.4886 4.1587 2.16151 7.16581 2.14578 7.18154V7.18082C2.10864 7.23082 2.07721 7.28511 2.05078 7.34154C2.57079 7.24725 5.5379 6.69876 6.12432 6.59018Z"
        fill={color || 'white'}
      />
      <path
        d="M12.9385 7.0918H7.05859L9.99856 17.771L12.9385 7.0918Z"
        fill={color || 'white'}
      />
      <path
        d="M17.9458 7.34137C17.9222 7.2828 17.8901 7.2278 17.8508 7.1778L15.5014 4.15701L15.4929 4.14844L13.875 6.58921L17.9458 7.34137Z"
        fill={color || 'white'}
      />
      <path
        d="M10.0019 17.8455H10.019L9.999 17.7705C9.99043 17.8191 9.96043 17.8505 10.0019 17.8455Z"
        fill={color || 'white'}
      />
      <path
        d="M6.68358 6.38603C7.05072 5.89104 8.75571 3.59107 9.0843 3.14453L5.03714 3.84452C5.02571 3.84738 5.01143 3.85024 5 3.8531C5.22572 4.18738 6.43358 6.01026 6.68358 6.38603Z"
        fill={color || 'white'}
      />
      <path
        d="M12.6992 6.51816C12.3328 6.02245 10.4256 3.44032 10.1036 3.0075C10.035 2.9975 9.965 2.9975 9.89643 3.0075C9.58287 3.43036 7.65717 6.03396 7.30078 6.51816H12.6992Z"
        fill={color || 'white'}
      />
      <path
        d="M13.3186 6.38603C13.5758 5.99674 14.77 4.20181 14.9993 3.8531C14.9665 3.83667 10.9536 3.15453 10.918 3.14453C11.2337 3.57382 12.963 5.90658 13.3186 6.38603Z"
        fill={color || 'white'}
      />
      <path
        d="M5.99417 10.7587C6.03917 10.7444 6.06988 10.7023 6.06988 10.6551C6.06988 10.608 6.03917 10.5658 5.99417 10.5523L5.77917 10.4887C5.21846 10.3258 4.78061 9.88726 4.61702 9.32726L4.55417 9.11225C4.53702 9.07011 4.49631 9.04297 4.4506 9.04297C4.4056 9.04297 4.36488 9.07011 4.34774 9.11225C4.22774 9.76297 3.7556 10.2937 3.12275 10.4887L2.90774 10.5515V10.5522C2.86275 10.5658 2.83203 10.608 2.83203 10.6551C2.83203 10.7022 2.86275 10.7444 2.90774 10.7587C3.55988 10.8765 4.09132 11.3494 4.28487 11.9829C4.31844 12.0551 4.32916 12.2865 4.4513 12.2758C4.57344 12.2858 4.58416 12.0587 4.61773 11.9829H4.61702C4.81201 11.3501 5.34276 10.878 5.99417 10.7587Z"
        fill={color || 'white'}
      />
      <path
        d="M6.46919 7.10938L2 7.93223C2.02714 8.04651 2.07786 8.15436 2.14929 8.24795L3.31927 9.75937C3.64642 9.54009 3.7207 9.19222 3.83855 8.84722C3.97141 8.63581 4.20355 8.50722 4.45355 8.50722C4.70355 8.50722 4.9364 8.63579 5.06927 8.84722C5.1007 8.9108 5.14712 9.0958 5.16998 9.1658H5.16927C5.31212 9.60937 5.69498 9.93365 6.1564 10.0001C6.70639 10.1394 6.75854 11.0301 6.25997 11.2679H6.25925C6.15568 11.3101 6.04926 11.3444 5.9414 11.3715C5.56782 11.4829 5.2764 11.7758 5.16639 12.1486L9.30846 17.4987C9.27632 17.1472 6.67564 7.94722 6.46919 7.10938Z"
        fill={color || 'white'}
      />
      <path
        d="M16.0098 13.3972C15.4205 13.2864 14.9255 12.8879 14.6905 12.3357C14.6505 12.2364 14.5998 12.06 14.5698 11.9543C14.5526 11.9129 14.5119 11.8857 14.4669 11.8857C14.4212 11.8857 14.3805 11.9129 14.3634 11.9543C14.2519 12.5786 13.8141 13.095 13.2162 13.3057C13.1577 13.3257 12.9848 13.3793 12.9234 13.3979V13.3972C12.8784 13.4107 12.8477 13.4522 12.8477 13.4993C12.8477 13.5464 12.8784 13.5872 12.9234 13.6007C12.9555 13.6072 13.1041 13.6564 13.1384 13.6664V13.6672C13.7734 13.8593 14.2462 14.3914 14.3634 15.0436C14.3777 15.0893 14.4191 15.12 14.4669 15.12C14.5141 15.12 14.5555 15.0886 14.5698 15.0436L14.6326 14.8257H14.6334C14.7955 14.2657 15.2341 13.8279 15.7948 13.6672L16.0098 13.6014V13.6007C16.0548 13.5879 16.0855 13.5464 16.0855 13.4993C16.0855 13.4522 16.0548 13.4107 16.0098 13.3972Z"
        fill={color || 'white'}
      />
      <path
        d="M4.58305 13.6841C4.09735 13.5955 3.70163 13.2441 3.55663 12.7719L3.50806 12.6083H3.50734C3.4902 12.5669 3.44948 12.5391 3.40448 12.5391C3.35949 12.5391 3.31806 12.5669 3.30091 12.6083C3.19948 13.1534 2.77306 13.5805 2.22806 13.6841C2.18306 13.6976 2.15234 13.7391 2.15234 13.7855C2.15234 13.8326 2.18306 13.8741 2.22806 13.8876L2.39163 13.9362C2.86448 14.0798 3.21591 14.4769 3.30092 14.9633C3.3152 15.0083 3.35663 15.0398 3.40449 15.0405C3.45235 15.0412 3.4952 15.0098 3.50735 14.9633C3.59592 14.4776 3.94807 14.0812 4.41949 13.9362L4.58306 13.8876C4.62806 13.8741 4.65877 13.8326 4.65877 13.7855C4.65877 13.7391 4.62805 13.6976 4.58305 13.6841Z"
        fill={color || 'white'}
      />
    </svg>
  ),
  leaf: ({
    className,
    width,
    height,
    color,
    ...props
  }: LucideProps & { width?: number; height?: number; color?: string }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      className={className}
      width={width || 20}
      height={height || 20}
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.83305 18.6671C3.17244 17.1173 3.9581 15.6823 4.91599 14.4188C5.43116 14.8859 6.04318 15.2633 6.71764 15.5266C8.28898 16.1386 10.2034 16.1257 12.0207 15.142C14.9317 13.5678 17.5985 9.48518 18.1295 1.44695C18.136 1.34076 18.103 1.23169 18.0277 1.1456C17.8755 0.969812 17.6108 0.950439 17.435 1.10255C15.233 3.00181 13.2197 3.40352 11.2911 3.78888C9.38316 4.16987 7.55352 4.53508 5.65573 6.21255C3.43081 8.17995 2.91632 10.3274 3.44017 12.1096C3.6217 12.7281 3.93023 13.3007 4.33562 13.8044C3.27084 15.1834 2.38695 16.7655 2.00948 18.4897C1.9607 18.7171 2.10491 18.9417 2.33236 18.9905C2.55981 19.0393 2.78438 18.8951 2.83318 18.6676L2.83305 18.6671ZM4.91599 14.4188L4.33552 13.8046C6.8784 10.8212 10.0992 8.93998 10.1136 8.93208C10.3137 8.81369 10.5721 8.88042 10.6904 9.0806C10.8088 9.28078 10.7421 9.53909 10.5419 9.65747C10.529 9.66608 7.3613 11.5136 4.91669 14.4196L4.91599 14.4188Z"
        fill={color || 'white'}
      />
    </svg>
  ),
  badgePercent: ({
    className,
    width,
    height,
    color,
    ...props
  }: LucideProps & { width?: number; height?: number; color?: string }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      className={className}
      width={width || 20}
      height={height || 20}
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.72332 1.47633C9.45587 0.841223 10.5442 0.841223 11.2767 1.47633L11.8558 1.97825C12.006 2.10901 12.2082 2.16342 12.4048 2.12525L13.1552 1.97988C14.1079 1.79552 15.0508 2.34048 15.3684 3.25739L15.6178 3.98022C15.6827 4.16864 15.8313 4.31726 16.0198 4.38224L16.7426 4.63157C17.6595 4.94911 18.2045 5.89203 18.0201 6.84479L17.8747 7.59523C17.8366 7.79177 17.891 7.994 18.0226 8.14424L18.5237 8.72332C19.1588 9.45587 19.1588 10.5442 18.5237 11.2767L18.0217 11.8558C17.891 12.006 17.8366 12.2082 17.8747 12.4048L18.0201 13.1552C18.2045 14.1079 17.6595 15.0508 16.7426 15.3684L16.0198 15.6178C15.8314 15.6827 15.6827 15.8313 15.6178 16.0198L15.3684 16.7426C15.0509 17.6595 14.108 18.2045 13.1552 18.0201L12.4048 17.8747C12.2082 17.8366 12.006 17.891 11.8558 18.0226L11.2767 18.5237C10.5441 19.1588 9.45583 19.1588 8.72332 18.5237L8.14424 18.0217C7.99399 17.891 7.79177 17.8366 7.59523 17.8747L6.84479 18.0201C5.89214 18.2045 4.94922 17.6595 4.63157 16.7426L4.38224 16.0198C4.31727 15.8314 4.16865 15.6827 3.98022 15.6178L3.25739 15.3684C2.34046 15.0509 1.79552 14.108 1.97988 13.1552L2.12525 12.4048C2.16342 12.2082 2.10901 12.006 1.97744 11.8558L1.47633 11.2767C0.841223 10.5441 0.841223 9.45583 1.47633 8.72332L1.97825 8.14424C2.10901 7.99399 2.16342 7.79177 2.12525 7.59523L1.97988 6.84479C1.79552 5.89214 2.34048 4.94922 3.25739 4.63157L3.98022 4.38224C4.16864 4.31727 4.31726 4.16865 4.38224 3.98022L4.63157 3.25739C4.94911 2.34046 5.89203 1.79552 6.84479 1.97988L7.59523 2.12525C7.79177 2.16342 7.994 2.10901 8.14424 1.97744L8.72332 1.47633ZM14.1346 11.3781C13.3736 10.6171 12.1392 10.6171 11.3781 11.3781C10.6171 12.1391 10.6171 13.3736 11.3781 14.1346C12.1391 14.8956 13.3736 14.8956 14.1346 14.1346C14.8956 13.3736 14.8956 12.1392 14.1346 11.3781ZM13.2161 12.2967C13.4695 12.5509 13.4695 12.9627 13.2161 13.2161C12.9627 13.4695 12.5509 13.4695 12.2967 13.2161C12.0433 12.9627 12.0433 12.5509 12.2967 12.2967C12.5509 12.0433 12.9627 12.0433 13.2161 12.2967ZM12.2967 6.7837L6.78373 12.2967C6.53032 12.5509 6.53032 12.9627 6.78373 13.2161C7.03713 13.4695 7.44888 13.4695 7.70309 13.2161L13.2161 7.70307C13.4695 7.44885 13.4695 7.0371 13.2161 6.7837C12.9627 6.5303 12.5509 6.5303 12.2967 6.7837ZM9.08136 5.40547C8.32036 4.64447 7.08507 4.64447 6.32486 5.40547C5.56386 6.16647 5.56386 7.40095 6.32486 8.16197C7.08503 8.92297 8.32034 8.92297 9.08136 8.16197C9.84236 7.40097 9.84236 6.16649 9.08136 5.40547ZM8.16199 6.32484C8.41621 6.57824 8.41621 6.98918 8.16199 7.2434C7.90859 7.4968 7.49684 7.4968 7.24344 7.2434C6.98922 6.98918 6.98922 6.57824 7.24344 6.32484C7.49684 6.07063 7.90859 6.07063 8.16199 6.32484Z"
        fill={color || 'white'}
      />
    </svg>
  ),
  facebook: Facebook,
  instagram: Instagram,
  twitter: Twitter,
  check: Check,
  percent: Percent,
  userCog: UserCog,
  // Tariff Comparison plan/feature icons (keys shared with the admin picker)
  tag: Tag,
  signal: SignalHigh,
  contract: RefreshCw,
  download: Download,
  data: Database,
  phone: Phone,
  infinity: InfinityIcon,
  piggyBank: PiggyBank,
  rocket: Rocket,
  headset: Headset,
  wifi: Wifi,
  shield: ShieldCheck,
  energy: Zap,
  tiktok: ({ ...props }: LucideProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      width={props.width || 20}
      height={props.height || 20}
      viewBox="0 0 24 24"
      xmlSpace="preserve"
    >
      <path d="M19.589 6.686a4.793 4.793 0 0 1-3.77-4.245V2h-3.445v13.672a2.896 2.896 0 0 1-5.201 1.743l-.002-.001.002.001a2.895 2.895 0 0 1 3.183-4.51v-3.5a6.329 6.329 0 0 0-5.394 10.692 6.33 6.33 0 0 0 10.857-4.424V8.687a8.182 8.182 0 0 0 4.773 1.526V6.79a4.831 4.831 0 0 1-1.003-.104z" />
    </svg>
  ),
  trustPilotStars: ({ ...props }: LucideProps) => (
    <svg
      {...props}
      width={props.width || '129'}
      height={props.height || '71'}
      viewBox="0 0 129 71"
      fill="none"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.8928 60.3509H15.3873L12.4512 51.5078L9.50476 60.3517L0 60.3421L7.69811 65.8124L4.75312 74.6459L12.4512 69.1844L20.1404 74.6459L17.2044 65.8124L24.8928 60.3509Z"
        fill="#022A1C"
      />
      <path
        d="M46.3689 44.5951H36.8634L33.9273 35.752L30.9808 44.5958L21.4761 44.5862L29.1742 50.0565L26.2292 58.89L33.9273 53.4286L41.6165 58.89L38.6804 50.0565L46.3689 44.5951Z"
        fill="#022A1C"
      />
      <path
        d="M59.0596 69.7044H49.5541L46.618 60.8613L43.6715 69.7052L34.1667 69.6956L41.8649 75.1659L38.9199 83.9994L46.618 78.538L54.3072 83.9994L51.3711 75.1659L59.0596 69.7044Z"
        fill="#022A1C"
      />
      <path
        d="M76.1428 51.4896H66.6373L63.7012 42.6465L60.7548 51.4903L51.25 51.4807L58.9481 56.9511L56.0031 65.7846L63.7012 60.3231L71.3904 65.7846L68.4544 56.9511L76.1428 51.4896Z"
        fill="#022A1C"
      />
      <path
        d="M97.6189 65.2748H88.1134L85.1773 56.4316L82.2308 65.2755L72.7261 65.2659L80.4242 70.7362L77.4792 79.5697L85.1773 74.1083L92.8665 79.5697L89.9304 70.7362L97.6189 65.2748Z"
        fill="#022A1C"
      />
      <path
        d="M102.5 39.6732H92.9943L90.0582 30.8301L87.1117 39.6739L77.6069 39.6643L85.305 45.1347L82.3601 53.9682L90.0582 48.5067L97.7474 53.9682L94.8113 45.1347L102.5 39.6732Z"
        fill="#022A1C"
      />
      <path
        d="M120.56 55.9193H111.054L108.118 47.0762L105.172 55.92L95.6667 55.9104L103.365 61.3808L100.42 70.2143L108.118 64.7528L115.807 70.2143L112.871 61.3808L120.56 55.9193Z"
        fill="#022A1C"
      />
      <path
        d="M126.417 27.8607H116.911L113.975 19.0176L111.028 27.8614L101.524 27.8518L109.222 33.3222L106.277 42.1557L113.975 36.6942L121.664 42.1557L118.728 33.3222L126.417 27.8607Z"
        fill="#022A1C"
      />
      <path
        d="M76.6309 27.8607H67.1254L64.1893 19.0176L61.2428 27.8614L51.738 27.8518L59.4362 33.3222L56.4912 42.1557L64.1893 36.6942L71.8785 42.1557L68.9424 33.3222L76.6309 27.8607Z"
        fill="#022A1C"
      />
      <path
        d="M105.428 14.0755H95.923L92.9869 5.23242L90.0404 14.0763L80.5356 14.0667L88.2338 19.537L85.2888 28.3705L92.9869 22.909L100.676 28.3705L97.74 19.537L105.428 14.0755Z"
        fill="#022A1C"
      />
      <path
        d="M128.369 -3.15689H118.863L115.927 -12L112.981 -3.15615L103.476 -3.16575L111.174 2.30458L108.229 11.1381L115.927 5.67662L123.616 11.1381L120.68 2.30458L128.369 -3.15689Z"
        fill="#022A1C"
      />
    </svg>
  ),
  bell: ({ ...props }: LucideProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      {...props}
    >
      <path d="M224,71.1a8,8,0,0,1-10.78-3.42,94.13,94.13,0,0,0-33.46-36.91,8,8,0,1,1,8.54-13.54,111.46,111.46,0,0,1,39.12,43.09A8,8,0,0,1,224,71.1ZM35.71,72a8,8,0,0,0,7.1-4.32A94.13,94.13,0,0,1,76.27,30.77a8,8,0,1,0-8.54-13.54A111.46,111.46,0,0,0,28.61,60.32,8,8,0,0,0,35.71,72Zm186.1,103.94A16,16,0,0,1,208,200H167.2a40,40,0,0,1-78.4,0H48a16,16,0,0,1-13.79-24.06C43.22,160.39,48,138.28,48,112a80,80,0,0,1,160,0C208,138.27,212.78,160.38,221.81,175.94ZM150.62,200H105.38a24,24,0,0,0,45.24,0ZM208,184c-10.64-18.27-16-42.49-16-72a64,64,0,0,0-128,0c0,29.52-5.38,53.74-16,72Z" />
    </svg>
  ),
  whatsapp: ({ ...props }: LucideProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="#25D366"
      {...props}
    >
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z" />
    </svg>
  ),
  youtube: ({ ...props }: LucideProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="#FF0000"
      {...props}
    >
      <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
    </svg>
  ),
  iosShare: ({
    width,
    height,
    ...props
  }: LucideProps & { width?: number; height?: number }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 48}
      height={height || 48}
      viewBox="0 0 48 48"
      fill="none"
      aria-hidden="true"
      {...props}
    >
      <rect
        x="10"
        y="18"
        width="28"
        height="22"
        rx="3"
        stroke="#181818"
        strokeWidth="2.5"
        fill="white"
      />
      <path
        d="M24 8 L24 28"
        stroke="#181818"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <path
        d="M16 14 L24 8 L32 14"
        stroke="#181818"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  iosAdd: ({
    width,
    height,
    ...props
  }: LucideProps & { width?: number; height?: number }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 48}
      height={height || 48}
      viewBox="0 0 48 48"
      fill="none"
      aria-hidden="true"
      {...props}
    >
      <rect
        x="10"
        y="10"
        width="28"
        height="28"
        rx="6"
        stroke="#181818"
        strokeWidth="2.5"
        fill="white"
      />
      <path
        d="M24 17 L24 31"
        stroke="#181818"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <path
        d="M17 24 L31 24"
        stroke="#181818"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </svg>
  ),
  iosHomeScreen: ({
    width,
    height,
    ...props
  }: LucideProps & { width?: number; height?: number }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 48}
      height={height || 48}
      viewBox="0 0 48 48"
      fill="none"
      aria-hidden="true"
      {...props}
    >
      <rect x="9" y="9" width="30" height="30" rx="7" fill="#2fd1cd" />
      <path
        d="M16 25 C16 19 21 16 24 16 C27 16 32 19 32 25 C32 30 28 33 24 33 C20 33 16 30 16 25 Z"
        fill="white"
      />
      <circle cx="24" cy="22" r="2" fill="#2fd1cd" />
    </svg>
  )
};
